import { Box, Group, Text, UnstyledButton } from '@mantine/core'

const RAIL_POSITIONS = ['Top', 'Right', 'Bottom', 'Left'] as const
type RailPos = typeof RAIL_POSITIONS[number];

interface Props {
  value: string | null;
  onChange: (pos: string) => void;
}

/**
 * Four-button toggle for selecting which side of a rail a part occupies.
 * Only intended to be rendered when the part category is in
 * RAIL_MOUNTABLE_CATEGORIES — the parent is responsible for the gate.
 */
export default function RailPositionSelector ({ value, onChange }: Props) {
  return (
    <Box>
      <Text size="xs" weight={600}
            sx={{
              color: 'var(--gs-muted)',
              textTransform: 'uppercase',
              letterSpacing: 0.8,
              marginBottom: 6,
              fontFamily: 'DM Sans, sans-serif'
            }}>
        Rail Position
      </Text>
      <Group spacing={6}>
        {RAIL_POSITIONS.map((pos) => {
          const active = value === pos
          return (
            <UnstyledButton
              key={pos}
              onClick={() => onChange(active ? '' : pos)}
              sx={{
                padding: '4px 12px',
                borderRadius: 4,
                border: `1px solid ${active ? 'var(--gs-accent)' : 'var(--gs-border)'}`,
                background: active ? 'rgba(232,93,4,0.12)' : 'var(--gs-surface)',
                color: active ? 'var(--gs-accent)' : 'var(--gs-muted)',
                fontSize: 12,
                fontFamily: 'DM Sans, sans-serif',
                fontWeight: active ? 600 : 400,
                cursor: 'pointer',
                transition: 'border-color 0.12s, background 0.12s, color 0.12s',
                '&:hover': {
                  borderColor: 'var(--gs-accent)',
                  color: 'var(--gs-accent)'
                }
              }}
            >
              {pos}
            </UnstyledButton>
          )
        })}
      </Group>
    </Box>
  )
}
